import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "./StyledDatePicker.css";

const StyledDatePicker = ({ value, ...props }) => {
  return <DatePicker className="soft-datepicker" selected={value} {...props} />;
};

export default StyledDatePicker;
